import {
    AccountInfo,
    InteractionRequiredAuthError,
    IPublicClientApplication,
    NavigationClient,
    NavigationOptions,
    PublicClientApplication,
} from "@azure/msal-browser";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

// Config object to be passed to Msal on creation

export const msalConfig = {
    auth: {
        clientId: "bd3776bf-aee2-47b3-975f-87fd8667c3f2",
        authority: "https://login.microsoftonline.com/cc8d834f-85f9-44cc-88e6-3e5b8b390dea/v2.0",
        redirectUri: "/",
        postLogoutRedirectUri: "/",
    },
    system: {
        allowNativeBroker: false, // Disables WAM Broker
    },
    cache: {
        cacheLocation: "localStorage", // Options: 'localStorage', 'sessionStorage'
        storeAuthStateInCookie: false, // Recommended to set to true if you experience issues in IE or Edge
    },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    //scopes: ["User.Read", "bd3776bf-aee2-47b3-975f-87fd8667c3f2/.default"],
    scopes: ["bd3776bf-aee2-47b3-975f-87fd8667c3f2/.default"],
};

export const getJWT = async (instance: IPublicClientApplication, accounts: AccountInfo[]) => {
    const tokenRequest = {
        ...loginRequest,
        account: instance.getActiveAccount() || accounts[0],
    };
    return await instance
        .acquireTokenSilent(tokenRequest)
        .then((response) => {
            return response.accessToken;
        })
        .catch(async (error) => {
            if (error instanceof InteractionRequiredAuthError) {
                await instance.acquireTokenRedirect(tokenRequest);
            }
            throw error;
        });
};

export const signout = async (instance: IPublicClientApplication, account: AccountInfo) => {
    return await instance.logoutRedirect({
        account: account,
        postLogoutRedirectUri: window.location.origin + "/",
    });
};

export class CustomNavigationClient extends NavigationClient {
    private router: AppRouterInstance;

    constructor(router: AppRouterInstance) {
        super();
        this.router = router;
    }

    /**
     * Navigates to other pages within the same web application
     * You can use the useRouter hook provided by next.js to take advantage of client-side routing
     * @param url
     * @param options
     */
    async navigateInternal(url: string, options: NavigationOptions) {
        const relativePath = url.replace(window.location.origin, "");
        if (options.noHistory) {
            this.router.replace(relativePath);
        } else {
            this.router.push(relativePath);
        }

        return false;
    }
}
